import { render, staticRenderFns } from "./commercialPage.vue?vue&type=template&id=00a852e3&scoped=true"
import script from "./commercialPage.vue?vue&type=script&lang=js"
export * from "./commercialPage.vue?vue&type=script&lang=js"
import style0 from "./commercialPage.vue?vue&type=style&index=0&id=00a852e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a852e3",
  null
  
)

export default component.exports